import script from "./c-button.vue?vue&type=script&setup=true&lang=js"
export * from "./c-button.vue?vue&type=script&setup=true&lang=js"

import "./c-button.vue?vue&type=style&index=0&id=77335ce4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-77335ce4"]])

export default __exports__